module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Book Virtual PD Session',
      "size": 'xl',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 overflow-auto"
  }, [_c('div', {
    staticClass: "my-7 flex justify-center font-semibold text-base"
  }, [_vm._v("\n      Request time for an introductory tour and interactive demonstration of\n      Parlay for a group of educators at your school or district.\n    ")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hubspotForm"
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e99d444e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/support_&_PD/components/virtualPdSessionModal.vue
// module id = 2320
// module chunks = 61